import React, { useState, useEffect } from "react";
import { Modal, Accordion } from "flowbite-react";
import { FaTicketAlt, FaMapMarkerAlt } from "react-icons/fa";

import ZonesImage from "../../assets/images/zones.jpg";

const InfoModal = ({ isOpen, onClose, eventData }) => {
  const [priceMapping, setPriceMapping] = useState({});

  useEffect(() => {
    if (eventData?.data?.ticketTypes) {
      const prices = eventData.data.ticketTypes.reduce((acc, item) => {
        acc[item._id] = item.price;
        return acc;
      }, {});
      setPriceMapping(prices);
    }
  }, [eventData]);

  return (
    <Modal show={isOpen} onClose={onClose} size="md">
      <Modal.Header className="text-lg font-semibold">🎟 Biletlər haqqında</Modal.Header>
      <Modal.Body className="bg-gray-50">
        <Accordion className="space-y-0">
          {eventData?.data?.ticketTypes?.map(({ _id, name, description }) => (
            <Accordion.Panel
              key={_id}
              className="bg-white rounded-xl shadow border border-gray-200 transition hover:shadow-md"
            >
              <Accordion.Title className="flex items-center justify-between px-4 py-3 text-base font-semibold text-gray-900">
                <div className="flex items-center gap-2">
                    <FaTicketAlt className="text-indigo-500" />
                    <span>{name.az}</span>
                    <span className="bg-indigo-100 text-indigo-700 text-sm px-3 py-1 rounded-full font-medium">
                        {priceMapping[_id]} ₼
                    </span>
                </div>
              </Accordion.Title>
              <Accordion.Content className="px-4 pb-4 pt-2 text-sm text-gray-600">
                <div dangerouslySetInnerHTML={{__html: description?.az}}></div>
              </Accordion.Content>
            </Accordion.Panel>
          ))}

          {eventData?.data?.hasZoneInfo ? <Accordion.Panel className="bg-white rounded-xl shadow border border-gray-200 hover:shadow-md">
            <Accordion.Title className="flex items-center gap-2 px-4 py-4 text-base font-semibold text-gray-900 align-middle">
                <div className="flex items-center gap-2">
                    <FaMapMarkerAlt className="text-pink-500" />
                    Zonalar
                </div>
            </Accordion.Title>
            <Accordion.Content className="px-4 pb-4 pt-2">
              <img
                src={ZonesImage}
                alt="Zonalar"
                className="rounded-md shadow-sm mt-2"
              />
            </Accordion.Content>
          </Accordion.Panel> : <></>}
        </Accordion>
      </Modal.Body>
    </Modal>
  );
};

export default InfoModal;
